import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import routes from '../../utils/routes';
import strings from '../../utils/strings';
import { CText } from '../../components/common';
import { FiArrowDown, FiArrowUp, FiSend, FiRepeat } from 'react-icons/fi';

const Wallet: React.FC = () => {
  const navigate = useNavigate();
  const colors = useAppSelector((state) => state.theme.theme);

  const actions = [
    { icon: FiArrowDown, title: strings.deposit, route: routes.myWalletDeposit, color: colors.green || '#1DCE5C' },
    { icon: FiArrowUp, title: strings.withdraw, route: routes.myWalletWithdraw, color: colors.alertColor || '#E82C81' },
    { icon: FiSend, title: strings.send, route: routes.sendWallet, color: colors.blue || '#0153FF' },
    { icon: FiRepeat, title: strings.transfer, route: routes.transferBalance, color: colors.primary },
  ];

  const transactions = [
    { type: 'Deposit', amount: '+$500.00', date: 'Today, 10:30 AM', positive: true },
    { type: 'Withdraw', amount: '-$200.00', date: 'Yesterday, 3:45 PM', positive: false },
    { type: 'Transfer', amount: '-$150.00', date: 'Oct 16, 2:15 PM', positive: false },
  ];

  return (
    <div
      className="p-4 md:p-6 lg:p-8 min-h-screen pb-24 lg:pb-8"
      style={{ backgroundColor: colors.backgroundColor }}
    >
      <div className="lg:max-w-5xl lg:mx-auto">
      <CText type="B24" color={colors.textColor} style={{ marginBottom: '24px' }}>
        {strings.wallet}
      </CText>

      {/* Balance Card */}
      <div
        className="rounded-2xl p-5 md:p-6 mb-5"
        style={{
          background: `linear-gradient(135deg, ${colors.gradient1} 0%, ${colors.gradient2} 50%, ${colors.gradient1} 100%)`,
          color: colors.white,
        }}
      >
        <CText type="r12" color={colors.white} style={{ marginBottom: '8px' }}>
          {strings.availableBalance}
        </CText>
        <CText type="B36" color={colors.white} style={{ marginBottom: '8px' }}>
          $15,432.75
        </CText>
        <CText type="r14" color={colors.white}>
          Last updated: Just now
        </CText>
      </div>

      {/* Action Buttons - 2 cols on mobile, 4 cols on tablet+ */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        {actions.map((action) => (
          <div
            key={action.title}
            className="flex flex-col items-center gap-2 p-4 rounded-xl cursor-pointer transition-transform duration-200 hover:scale-105 border"
            style={{
              backgroundColor: colors.inputBackground,
              borderColor: colors.borderColor,
            }}
            onClick={() => action.route && navigate(action.route)}
          >
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: `${action.color}20` }}
            >
              {React.createElement(action.icon as any, { size: 24, color: action.color })}
            </div>
            <CText type="M12" color={colors.textColor} style={{ textAlign: 'center' }}>
              {action.title}
            </CText>
          </div>
        ))}
      </div>

      {/* Recent Transactions */}
      <div>
        <CText type="B18" color={colors.textColor} style={{ marginBottom: '16px' }}>
          Recent Transactions
        </CText>
        {transactions.map((transaction, index) => (
          <div
            key={index}
            className="flex justify-between items-center p-4 rounded-xl mb-2 border"
            style={{
              backgroundColor: colors.inputBackground,
              borderColor: colors.borderColor,
            }}
          >
            <div>
              <CText type="M14" color={colors.textColor}>{transaction.type}</CText>
              <CText type="r12" color={colors.grayScale500}>{transaction.date}</CText>
            </div>
            <CText
              type="M16"
              color={transaction.positive ? colors.green : colors.textColor}
            >
              {transaction.amount}
            </CText>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default Wallet;
